package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.repository.OwnerRepository

class UpdateOwnerBusinessNameUseCase(
    private val ownerRepository: OwnerRepository
) {
    suspend operator fun invoke(ownerId: String, newBusinessName: String): Result<Unit> {
        return ownerRepository.updateBusinessName(ownerId, newBusinessName)
    }
}
